import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';

import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

import { AppRoutingModule } from './app.routing';
import { ComponentsModule } from './components/components.module';

import { AppComponent } from './app.component';

import { DashboardComponent } from './dashboard/dashboard.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { TableListComponent } from './table-list/table-list.component';
import { TypographyComponent } from './typography/typography.component';
import { IconsComponent } from './icons/icons.component';
import { MapsComponent } from './maps/maps.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { UpgradeComponent } from './upgrade/upgrade.component';
import { AgmCoreModule } from '@agm/core';

import { MatCardModule } from '@angular/material/card';

import { MatButtonModule } from '@angular/material/button';

import { MatButtonToggleModule } from '@angular/material/button-toggle';


import { NgxQrcodeStylingModule } from 'ngx-qrcode-styling';

import { MatInputModule } from '@angular/material/input';
import { MatRippleModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatStepperModule } from '@angular/material/stepper';
import { MatRadioModule } from '@angular/material/radio';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

import { MatCheckboxModule } from '@angular/material/checkbox';

import { MatSnackBarModule } from '@angular/material/snack-bar';


import { MatExpansionModule } from '@angular/material/expansion';
import { CdkAccordionModule } from '@angular/cdk/accordion';

import { DragDropModule } from '@angular/cdk/drag-drop';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';


import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';


import { MatTabsModule } from '@angular/material/tabs';


import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { AuthentificationComponent } from './authentification/authentification.component';
import { DeliverymanagerComponent } from './deliverymanager/deliverymanager.component';
import { CommandesComponent } from './commandes/commandes.component';
import { LivraisonComponent } from './livraison/livraison.component';
import { PartenairesComponent } from './partenaires/partenaires.component';
import { DetailcommandeComponent } from './detailcommande/detailcommande.component';

import { Deliverymodale } from './livraison/livraison.component';
import { SavComponent } from './sav/sav.component';

import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ParametrageComponent } from './parametrage/parametrage.component';
import { PrimeconfigComponent } from './primeconfig/primeconfig.component';
import { TypedefdialogComponent } from './typedefdialog/typedefdialog.component';
import { FormulemakerComponent } from './formulemaker/formulemaker.component';
import { VehiculeparamComponent } from './vehiculeparam/vehiculeparam.component';
import { FormulasComponent } from './formulas/formulas.component';
import { SelectedAssuranceComponent } from './selected-assurance/selected-assurance.component';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { RecurrentComponent } from './recurrent/recurrent.component';
import { CustomParameterComponent } from './custom-parameter/custom-parameter.component';
import { PredefparamchooseComponent } from './predefparamchoose/predefparamchoose.component';
import { ConfirmsouscriptionComponent } from './confirmsouscription/confirmsouscription.component';
import { UsrcreationComponent } from './usrcreation/usrcreation.component';
import { AddtypeinsuranceComponent } from './addtypeinsurance/addtypeinsurance.component';
import { AddbigcategComponent } from './addbigcateg/addbigcateg.component';
import { AddgarantieComponent } from './addgarantie/addgarantie.component';
import { TooltipComponent } from './tooltip/tooltip.component';
import { TooltipDirective } from './tooltip.directive';
import { ConstantesComponent } from './constantes/constantes.component';

import { DetailsComponent } from './details/details.component';
import { DetailopsComponent } from './detailops/detailops.component';
import { PackagingComponent } from './packaging/packaging.component';
import { PackageComponent } from './package/package.component';
import { PackagepublicComponent } from './packagepublic/packagepublic.component';
import { ComptafinancesComponent } from './comptafinances/comptafinances.component';
import { FraischargeComponent } from './fraischarge/fraischarge.component';
import { KhandalguiComponent } from './khandalgui/khandalgui.component';

import { ConfigfraisparamsComponent } from './configfraisparams/configfraisparams.component';
import { AvenantsComponent } from './avenants/avenants.component';

import { AvenantblockComponent } from './avenantblock/avenantblock.component';

import { ImpressionTPVComponent } from './impression-tpv/impression-tpv.component';
import { PaymantmodalComponent } from './paymantmodal/paymantmodal.component';
import { InvoiceComponent } from './invoice/invoice.component';
import { PrintpropositionComponent } from './printproposition/printproposition.component';
import { StockComponent } from './stock/stock.component';
import { AddProductDialogComponent } from './add-product-dialog/add-product-dialog.component';
import { StockTransferComponent } from './stock-transfer/stock-transfer.component';
import { TransferValidationComponent } from './transfer-validation/transfer-validation.component';
import { ProductSelectionDialogComponent } from './product-selection-dialog/product-selection-dialog.component';
import { ExpenseTrackingComponent } from './expense-tracking/expense-tracking.component';
import { ExpenseDialogComponent } from './expense-dialog/expense-dialog.component';
import { PriceDialogComponent } from './price-dialog/price-dialog.component';
import { TextDescriptionDialogComponent } from './text-description-dialog/text-description-dialog.component';
import { AudioDescriptionDialogComponent } from './audio-description-dialog/audio-description-dialog.component';
import { QrCodeDescriptionDialogComponent } from './qr-code-description-dialog/qr-code-description-dialog.component';
import { PhotoDialogComponent } from './photo-dialog/photo-dialog.component';
import { DepotDialogComponent } from './depot-dialog/depot-dialog.component';
import { ProductDetailsComponent } from './product-details/product-details.component';
import { MouvementsStockComponent } from './mouvements-stock/mouvements-stock.component';
import { VenteComponent } from './vente/vente.component';
import { BarreCommandeComponent } from './barre-commande/barre-commande.component';
import { ListeProduitsComponent } from './liste-produits/liste-produits.component';
import { PanierComponent } from './panier/panier.component';
import { FormulaireClientComponent } from './formulaire-client/formulaire-client.component';
import { ResumeFactureComponent } from './resume-facture/resume-facture.component';
import { InventaireComponent } from './inventaire/inventaire.component';
import { HistoinventaireComponent } from './histoinventaire/histoinventaire.component';
import { CartComponent } from './cart/cart.component';
import { DecisionDashboardComponent } from './decision-dashboard/decision-dashboard.component';

import { MatBadgeModule } from '@angular/material/badge';
import { CustomerInfoComponent } from './customer-info/customer-info.component';
import { FactureComponent } from './facture/facture.component';
import { PaiementComponent } from './paiement/paiement.component';
import { DetailCommandeComponent } from './detail-commande/detail-commande.component';
import { StatstockComponent } from './statstock/statstock.component';

import { CrmComponent } from './crm/crm.component';
import { StockEntreeComponent } from './stock-entree/stock-entree.component';

import { ScrollingModule } from '@angular/cdk/scrolling';
import { HistostocksComponent } from './histostocks/histostocks.component';
import { ModificationgeneraleComponent } from './modificationgenerale/modificationgenerale.component';
import { DetailStockStatComponent } from './detail-stock-stat/detail-stock-stat.component';
import { EditDepotComponent } from './edit-depot/edit-depot.component';
import { EditBoutiqueComponent } from './edit-boutique/edit-boutique.component';
import { EditCMUPComponent } from './edit-cmup/edit-cmup.component';
import { StockReceptionComponent } from './stock-reception/stock-reception.component';



import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { CaisseComponent } from './caisse/caisse.component';
import { BanqueComponent } from './banque/banque.component';
import { CreditFournisseurComponent } from './credit-fournisseur/credit-fournisseur.component';
registerLocaleData(localeFr);

@NgModule({
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    BrowserModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatRippleModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatTooltipModule,
    MatDialogModule,
    MatStepperModule,
    MatRadioModule,
    MatChipsModule,
    MatIconModule,
    MatListModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatProgressSpinnerModule,
    MatNativeDateModule,
    HttpClientModule,
    ComponentsModule,
    PdfViewerModule,
    DragDropModule,
    RouterModule,

    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatCardModule,
    MatCheckboxModule,
    MatSnackBarModule,

    MatTabsModule,
    MatBadgeModule,
    ScrollingModule,

    MatExpansionModule,
    CdkAccordionModule,
    NgxQrcodeStylingModule,


    AppRoutingModule,
    AgmCoreModule.forRoot({
      apiKey: 'YOUR_GOOGLE_MAPS_API_KEY'
    }),
  ],

  declarations: [
    AppComponent,
    AdminLayoutComponent,
    AuthentificationComponent,
    DetailcommandeComponent,
    Deliverymodale,
    SavComponent,
    ParametrageComponent,
    PrimeconfigComponent,
    TypedefdialogComponent,
    FormulemakerComponent,
    VehiculeparamComponent,
    FormulasComponent,
    SelectedAssuranceComponent,
    ConfirmationDialogComponent,
    RecurrentComponent,
    CustomParameterComponent,
    PredefparamchooseComponent,
    ConfirmsouscriptionComponent,
    UsrcreationComponent,
    AddtypeinsuranceComponent,
    AddbigcategComponent,
    AddgarantieComponent,
    TooltipComponent,
    TooltipDirective,
    ConstantesComponent,
    DetailopsComponent,
    DetailsComponent,
    PackagingComponent,
    PackageComponent,
    PackagepublicComponent,
    ComptafinancesComponent,
    FraischargeComponent,
    KhandalguiComponent,
    ConfigfraisparamsComponent,
    AvenantsComponent,
    AvenantblockComponent,
    ImpressionTPVComponent,
    PaymantmodalComponent,
    InvoiceComponent,
    PrintpropositionComponent,
    StockComponent,
    AddProductDialogComponent,
    StockTransferComponent,
    TransferValidationComponent,
    ProductSelectionDialogComponent,
    ExpenseTrackingComponent,
    ExpenseDialogComponent,
    PriceDialogComponent,
    TextDescriptionDialogComponent,
    AudioDescriptionDialogComponent,
    QrCodeDescriptionDialogComponent,
    PhotoDialogComponent,
    DepotDialogComponent,
    ProductDetailsComponent,
    MouvementsStockComponent,
    VenteComponent,
    BarreCommandeComponent,
    ListeProduitsComponent,
    PanierComponent,
    FormulaireClientComponent,
    ResumeFactureComponent,
    InventaireComponent,
    HistoinventaireComponent,
    CartComponent,
    CommandesComponent,
    DecisionDashboardComponent,
    CustomerInfoComponent,
    FactureComponent,
    PaiementComponent,
    DetailCommandeComponent,
    StatstockComponent,
    CrmComponent,
    StockEntreeComponent,
    HistostocksComponent,
    ModificationgeneraleComponent,
    DetailStockStatComponent,
    EditDepotComponent,
    EditBoutiqueComponent,
    EditCMUPComponent,
    StockReceptionComponent,
    CaisseComponent,
    BanqueComponent,
    CreditFournisseurComponent
  ],
  exports: [],
  providers: [],
  bootstrap: [AppComponent]
})

export class AppModule {

  constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
    iconRegistry.addSvgIcon(
      'whatsapp',
      sanitizer.bypassSecurityTrustResourceUrl('assets/icons/whatsapp.svg')
    );
  }


}
